export class CompanyHomeOwnerSearchByNameResultDto {
    ownerId: number;
    customerId: string;
    companyName: string;
    address01: string;
    address02: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
}
